module.exports = __webpack_public_path__ + "static/img/bg4.383524d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg4.png
// module id = fXWU
// module chunks = 1